// 타지점(발주) 요구사항 프리셋 문구
// 항목을 추가/수정/삭제할 때는 BRANCH_REQUEST_PRESETS 배열만 수정하면
// 콘솔 주문상세(TransactionDetail)와 지점 포털 주문상세(BranchOrderDetail)에 함께 반영됩니다.

export const BRANCH_REQUEST_DIRECT_INPUT = "직접입력";

export const BRANCH_REQUEST_PRESETS: string[] = [
    "리본 글씨 이미지로 첨부했습니다. \r\n직함인 < > 는 작게 써주세요! 감사합니다.",
    "[배송 전 사진] 부탁드립니다. 감사합니다.",
    "★배송전사진★ 직함인 < > 는 작게 써주세요! \r\n감사합니다.",
    "★배송전사진+현장사진★ 직함인 < > 는 작게 써주세요! \r\n감사합니다.",
];

// SelectBox 에 그대로 넘길 수 있는 옵션 목록 (첫 항목은 항상 직접입력)
export const BRANCH_REQUEST_OPTIONS: { value: string; label: string }[] = [
    { value: BRANCH_REQUEST_DIRECT_INPUT, label: BRANCH_REQUEST_DIRECT_INPUT },
    ...BRANCH_REQUEST_PRESETS.map(text => ({ value: text, label: text })),
];

// 저장된 요구사항 값이 프리셋 문구인지 여부 (아니면 직접입력으로 취급)
export const isBranchRequestPreset = (request: string): boolean => BRANCH_REQUEST_PRESETS.includes(request);
